module.exports = __webpack_public_path__ + "media/images/lane/Tablet-59b191397096ee2ae395cad5498969cd.svg";